import request from '@/utils/request'


export function getUploadSecret(params) {
  return request({
    url: '/file/getuploadsecret',
    method: 'get',
    params:params
  })
}

export function getCVFiles(params) {
  return request({
    url:'/file/getcvfiles',
    method: 'get',
    params:params
  })
}
